// Sayaç metnini çark sütunlarına bölme (components/stat/animated-counter.tsx). Saf mantık; testi counter-parts.test.ts.
export type CounterPart =
  { key: string; digit: number; order: number } | { key: string; text: string }

/** Ondalık ayırıcıyı ve binlik grubu da içeren rakam dizisi: `1.234,56`, `12`, `0,5`. */
const RUN = /\d[\d.]*(?:,\d+)?/g

/**
 * Biçimli metni basamak sütunlarına böler. Sütunlar basamak değerine göre anahtarlanır (birler basamağı hep
 * "i0"): 999 → 1.000 olurken birler sütunu birler sütunu kalır. Rakam olmayanlar (işaret, `₺`, `%`, ayırıcı) metindir.
 */
export function partsFor(text: string): CounterPart[] {
  const parts: CounterPart[] = []
  let order = 0
  let cursor = 0
  let run = 0
  for (const match of text.matchAll(RUN)) {
    const start = match.index
    if (start > cursor) pushText(parts, text.slice(cursor, start), `t${cursor}`)
    const token = match[0]
    const [integerPart = '', fractionPart] = token.split(',')
    let place = integerPart.replace(/\./g, '').length
    let fraction = 0
    for (const char of integerPart) {
      if (char === '.') parts.push({ key: `r${run}g${place}`, text: '.' })
      else parts.push({ key: `r${run}i${--place}`, digit: Number(char), order: order++ })
    }
    if (fractionPart !== undefined) {
      parts.push({ key: `r${run}d`, text: ',' })
      for (const char of fractionPart)
        parts.push({ key: `r${run}f${fraction++}`, digit: Number(char), order: order++ })
    }
    cursor = start + token.length
    run += 1
  }
  if (cursor < text.length) pushText(parts, text.slice(cursor), `t${cursor}`)
  return parts
}

function pushText(parts: CounterPart[], value: string, key: string) {
  // Boşluk dahil her karakter ayrı sembol; anahtar konumdan türer, ön ek/son ek sabit kalır.
  Array.from(value).forEach((char, index) => parts.push({ key: `${key}-${index}`, text: char }))
}

/** İlk sayının değeri (yön için): `-1.234,5%` → -1234.5. Sayı yoksa NaN. */
export function numericValue(text: string): number {
  const match = /(-?)(\d[\d.]*(?:,\d+)?)/.exec(text)
  if (!match) return NaN
  const value = Number((match[2] ?? '').replace(/\./g, '').replace(',', '.'))
  return match[1] ? -value : value
}
